module.exports = __webpack_public_path__ + "static/media/Pattern7.3ea64762.jpg";